export const getRandomDelay = () => -(Math.random() * 0.7 + 0.05);
